import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const PageOne = Loadable(lazy(() => import('../pages/PageOne')));
export const PageNotFound = Loadable(lazy(() => import('../pages/Page404')));
// quiz
export const QuizListPage = Loadable(lazy(() => import('../pages/dashboard/competition/quiz/list')));
export const QuizDetailPage = Loadable(lazy(() => import('../pages/dashboard/competition/quiz/detail')));
export const QuizModifyPage = Loadable(lazy(() => import('../pages/dashboard/competition/quiz/modify')));
export const NewQuizModifyPage = Loadable(lazy(() => import('../pages/dashboard/competition/quiz/modifyNew')));
// question
export const QuestionDetailPage = Loadable(lazy(() => import('../pages/dashboard/bank/question/detail')));
export const QuestionListPage = Loadable(lazy(() => import('../pages/dashboard/bank/question/list')));
export const ModifyQuestionPage = Loadable(lazy(() => import('../pages/dashboard/bank/question/modify')));
// reward
export const RewardListPage = Loadable(lazy(() => import('../pages/dashboard/reward/list')));
export const RewardDetailPage = Loadable(lazy(() => import('../pages/dashboard/reward/detail')));
export const ModifyRewardPage = Loadable(lazy(() => import('../pages/dashboard/reward/modify')));
// participant
export const ParticipantListPage = Loadable(lazy(() => import('../pages/dashboard/users/participants/list')));
export const ParticipantDetailPage = Loadable(lazy(() => import('../pages/dashboard/users/participants/detail')));
export const ParticipantEditPage = Loadable(lazy(() => import('../pages/dashboard/users/participants/edit')));
// reports
export const CompetitionReportPage = Loadable(lazy(() => import('../pages/dashboard/reports/competition')));
export const QuestionsReportPage = Loadable(lazy(() => import('../pages/dashboard/reports/questions')));
export const UsersReportPage = Loadable(lazy(() => import('../pages/dashboard/reports/users')));
// accountant
export const AccountantPage = Loadable(lazy(() => import('../pages/dashboard/accountant/main')));
export const WithdrawRequest = Loadable(lazy(() => import('../pages/dashboard/accountant/withdrawRequest')));
export const TransactionList = Loadable(lazy(() => import('../pages/dashboard/accountant/transactionList')));
// giveaway
export const GiveawayListPage = Loadable(lazy(() => import('../pages/dashboard/giveaway/list')));
// shop
export const ShopListPage = Loadable(lazy(() => import('../pages/dashboard/shop/shopList')));
export const ShopModifyPage = Loadable(lazy(() => import('../pages/dashboard/shop/modifyShop')));
